// 前缀 --> 默认路由、高亮
// 前缀也支持 'prefix/sub/' 的字符串形式
const RouteMap = {
  default: {
    defaultRoute: '/resourcemanagement/overview',
    highlight: 'jdccsoverview'
  },
  resourcemanagement: {
    defaultRoute: '/resourcemanagement/overview',
    highlight: 'jdccsoverview'
  },
  cabinet: {
    defaultRoute: '/cabinet/list',
    highlight: 'cabinet'
  },
  equipment: {
    defaultRoute: '/equipment/list',
    highlight: 'device'
  },
  ipAddress: {
    defaultRoute: '/ipAddress/list',
    highlight: 'ipAddress'
  },
  bandwidth: {
    defaultRoute: '/bandwidth/list',
    highlight: 'bandwidth'
  },
  worksheet: {
    defaultRoute: '/worksheet/init',
    highlight: 'submitTicket'
  },
  myworksheet: {
    defaultRoute: '/myworksheet/list',
    highlight: 'myTickets'
  },
  bandwidthtraffic: {
    defaultRoute: '/bandwidthtraffic/list',
    highlight: 'bandwidthtraffic'
  },
  alarmrules: {
    defaultRoute: '/alarmrules/list',
    highlight: 'alarmrules'
  },
  alarmhistory: {
    defaultRoute: '/alarmhistory/list',
    highlight: 'alarmhistory'
  },
  aidc:{
    defaultRoute: '/aidc/create',
  },
  bill: {
    defaultRoute: '/bill/list',
    highlight: 'resourcebill'
  },
  inspectionDevice: {
    defaultRoute: '/inspectionDevice/list',
    highlight: 'InspectionDeviceList'
  },
  inspectionRegion: {
    defaultRoute: '/inspectionRegion/list',
    highlight: 'InspectionRegionList'
  },
};

const _getConfig = (key) => {
  if (!key) return null;
  const m = Object.keys(RouteMap).reduce((obj, k) => {
    obj[k.toLowerCase()] = {
      _key: k,
      ...RouteMap[k]
    };
    return obj;
  }, {});
  return m[key.toLowerCase()];
};

const _splitRoute = (route) => {
  let prefix;
  let rest;
  const findMap = Object.keys(RouteMap).filter((key) => {
    key = key.replace(/\/+$/, '').replace(/^\/+/, ''); // 去掉首尾斜杠
    if (/^\//.test(route)) key = `/${key}`;
    const re = new RegExp(`^(${key.toLowerCase()})/`, 'i');
    return re.test(route);
  });
  if (findMap.length) {
    prefix = findMap[0];
    const preLng = prefix.length + /^(\/*)/.exec(route)[1].length;
    rest = route.substr(preLng).replace(/\/+$/, '').replace(/^\//, '');
  } else {
    const reTest = /^\/?(.*?)\/(.*)$/.test(route);
    prefix = reTest ? RegExp.$1 : null;
    rest = reTest ? RegExp.$2 : null;
  }
  // console.log(findMap, route, prefix, rest)
  return {
    prefix,
    rest
  };
};

export function getRoutePath (from) {
  let to = from;
  const reTest = _splitRoute(from);
  const { prefix, rest } = reTest;
  const cfg = reTest
    ? _getConfig(prefix)
    : false;
  if (!reTest || !cfg) { // 不是合法的路由格式
    to = RouteMap.default.defaultRoute;
  } else if (cfg) {
    console.log(from, prefix, rest, cfg._key);
    if (rest === '(.*)') {
      // 兼容上一版菜单的配置
      to = cfg.defaultRoute;
    } else {
      // 修正可能的小写，补全开头斜杠
      const pre = new RegExp(`^/*${prefix}`, 'i');
      to = to.replace(pre, cfg._key).replace(/^\/*/, '/');
    }
  }
  return to;
}

export function getHighlight (from) {
  const reTest = _splitRoute(from);
  if (!reTest) return RouteMap.default.highlight;

  const { prefix } = reTest;
  const cfg = _getConfig(prefix);

  return cfg ? cfg.highlight : RouteMap.default.highlight;
}

export default function(router) {
  // 应 fanyang@jd.com 的要求增加的代码
  // 用于匹配新的 jq 控制台菜单组件
  // 在页面路由切换时不至刷新页面
  window.toRoutePath = function(from, highlightOnly = false) {
    console.log('菜单传入的路径：', from, '1');

    if (!from || !from.length) return;

    // 1. 菜单高亮
    const hl = getHighlight(from);
    if (typeof window.Ynavi !== 'undefined') {
      setTimeout(() => {
        Ynavi.setCurrPage(hl);
      }, 200);
    }

    console.log('\t菜单高亮：', hl);

    if (highlightOnly) return;

    // 2. 修正跳转
    const to = getRoutePath(from);
    router.push(to);

    console.log('\t实际跳转到：', to);
  };
  window.addEventListener('DOMContentLoaded', () => {
    const { pathname, search, hash } = window.location;
    window.toRoutePath(`${pathname}${search}${hash}`); // 会自动都转为小写
  });
}



// WEBPACK FOOTER //
// ./src/menuChecker.js